// extracted by mini-css-extract-plugin
module.exports = {"customCarousel":"_27ni8"};